import { Link } from 'react-router-dom';
import styled from 'styled-components';

import AquaLogo from 'assets/aqua/aqua-logo-text.svg';
import Dune from 'assets/orgs/duneLogoCircle.svg';

import { commonMaxWidth, commonSectionPaddings, flexAllCenter, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, MAX_WIDTHS } from 'styles/style-constants';

export const FooterBlock = styled.footer`
    ${commonSectionPaddings};
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 16rem;
    margin: 5.4rem 0 4.8rem 0;

    ${respondDown(Breakpoints.xl)`
        margin: 3.6rem 0 3rem 0;
    `}

    ${respondDown(Breakpoints.md)`
        height: auto;
        margin: 3.6rem 0 3rem 0;
    `}

    ${respondDown(Breakpoints.sm)`
        margin: 3.6rem 0 3rem 0;
    `}

    ${respondDown(Breakpoints.xs)`
        margin: 3.6rem 0 3.6rem 0;
    `}
`;

export const Wrapper = styled.div<{ $isWide: boolean }>`
    max-width: ${props => (props.$isWide ? MAX_WIDTHS.wide : MAX_WIDTHS.common)};
    display: flex;
    gap: 3.2rem;
    width: 100%;

    ${respondDown(Breakpoints.sm)`
        flex-direction: column;
        gap: 2.4rem;
    `}
`;

export const LogoWithDesc = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: 180%;
    flex: 1;

    ${respondDown(Breakpoints.xs)`
        padding: 0 0.8rem;
    `}
`;

export const Description = styled.div`
    font-size: 1.4rem;
    color: ${COLORS.textDark};
    margin-top: 3.2rem;

    ${respondDown(Breakpoints.sm)`
        margin-top: 2.4rem;
    `}
`;

export const LinksAndCopyright = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    line-height: 180%;
    flex: 1;
    color: ${COLORS.textDark};
`;

export const ExchangesAndCopyright = styled.div`
    font-size: 1.2rem;
    line-height: 180%;
    color: ${COLORS.textDark};
    text-decoration: none;
    margin-top: auto;
    padding-top: 2.4rem;
    display: flex;
    align-items: end;
    justify-content: center;
    flex-direction: column;

    ${respondDown(Breakpoints.sm)`
        padding: 0 0.8rem;
        flex-direction: row-reverse;
        justify-content: space-between;
        width: 100%;
        margin-top: 2.4rem;
    `}

    ${respondDown(Breakpoints.xs)`
        flex-direction: column;
        align-items: start;
        gap: 0.8rem;
    `}
`;

export const Exchanges = styled.span``;

export const Aqua = styled(AquaLogo)`
    height: 3.8rem;
    color: ${COLORS.textPrimary};
`;

export const DocLinks = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 0.8rem;

    ${respondDown(Breakpoints.sm)`
        width: 100%;
    `}

    ${respondDown(Breakpoints.xs)`
        width: 100%;
        flex-direction: column;
    `}
`;

export const AquaLinks = styled.div`
    display: flex;
    gap: 1.6rem;
    margin-top: 1.2rem;

    ${respondDown(Breakpoints.sm)`
        padding: 0 0.8rem;
    `}
`;

export const AquaLink = styled(Link)`
    font-size: 1.2rem;
    line-height: 180%;
    color: ${COLORS.purple500};
    text-decoration: none;
`;

export const MailLink = styled.a`
    font-size: 1.2rem;
    line-height: 180%;
    color: ${COLORS.purple500};
    text-decoration: none;
`;

export const DocsLink = styled.a`
    ${flexAllCenter};
    border-radius: 0.5rem;
    background: ${COLORS.controlBackground};
    border: 0.1rem solid ${COLORS.controlBorder};
    padding: 1.2rem 1.6rem;
    text-decoration: none;
    color: ${COLORS.textDark};
    white-space: nowrap;

    &:hover {
        background: ${COLORS.controlHover};
    }

    span {
        margin-left: 0.3rem;
    }

    svg {
        margin-right: 0.5rem;
    }

    ${respondDown(Breakpoints.md)`
        background: ${COLORS.gray100};
    `}

    ${respondDown(Breakpoints.sm)`
        flex: 1;
        span {
            display: none;
        }
    `}
`;

export const DuneLogo = styled(Dune)`
    height: 1.6rem;
    width: 1.6rem;
    overflow: visible;
`;

export const CompactFooter = styled.footer`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
    pointer-events: none;

    ${respondDown(Breakpoints.md)`
        position: static;
        background: ${COLORS.gray50};
    `}
`;

export const CompactFooterContent = styled.div`
    ${commonMaxWidth};
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 0 4rem;

    > * {
        pointer-events: auto;
    }

    ${respondDown(Breakpoints.md)`
        padding: 0 1.6rem;
    `}
`;

export const FooterControls = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 1.6rem;
    margin-top: 1.6rem;

    ${respondDown(Breakpoints.sm)`
        justify-content: space-between;
        width: 100%;
    `}
`;
